module.exports = __webpack_public_path__ + "static/assets/27802141bca7404b477168369bf3475d.svg";